module.exports = __webpack_public_path__ + "img/mp.856e5cc5.png";